// src/App.js
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "./App.css";
import Home from "./components/Home/Home";
import ScrollToTop from "./components/ScrollToTop"; 
import Header from "./components/Header";
import Footer from "./components/Footer";
// Services Pages
import AIServices from "./components/AIServices";
import WebDevelopment from "./components/WebDevelopment/WebDevelopment";
import MobileAppDevelopment from "./components/MobileAppDevelopment";
import SoftwareConsulting from "./components/software_consulting/SoftwareConsulting";
import ThirdPartyIntegration from "./components/ThirdPartyIntegration";
import CustomDevelopment from "./components/CustomDevelopment";
import EnterpriseApplication from "./components/EnterpriseApplication";
import Energy from "./components/Energy";
import Construction from "./components/Construction";
import Warehouse from "./components/Warehouse";
import Manufacture from "./components/Manufacture";
import Ecommerce from "./components/Ecommerce";

// Industries Pages
import DigitalTransformation from "./components/DigitalTransformation";
import Logistics from "./components/Logistics";
import Healthcare from "./components/Healthcare";
import FinancialServices from "./components/FinancialServices";
import Education from "./components/Education";
import Hospitality from "./components/Hospitality";
import Entertainment from "./components/Entertainment";

// Company Pages
import OurAdvantages from "./components/OurAdvantages";
import OurStory from "./components/OurStory";
import PeopleOfLentera from "./components/PeopleOfLentera";
import OurBrand from "./components/OurBrand";
// import Certification from './components/Certifications';
import Careers from "./components/Careers";
import SalesandMarketing from "./components/careers/SalesandMarketing";
import JAVA from "./components/careers/JAVA";
import Hireus from "./components/careers/Hireus";
import Cookie from "./components/Cookie";
import Privacy from "./components/Privacy";
import Terms from "./components/Terms";
import Copyrights from "./components/Copyrights";
import Power from "./components/careers/Power";
import Angular from "./components/careers/Angular";
import Designer from "./components/careers/Designer";
import Flutter from "./components/careers/Flutter";
import Python from "./components/careers/Python";

import React from "./components/careers/React";
import PHP from "./components/careers/PHP";

import BlogListing from "./components/BlogListing";
import BlogDetail from "./components/BlogDetail";

// Other Pages
import ContactUs from "./components/ContactUs";

function App() {
  return (
    <Router>
      
      <ScrollToTop />
      <Header /> 
      <Routes>
       
        <Route path="/" element={<Home />} />

       

        <Route path="/services/ai-services/" element={<AIServices />} />
        <Route path="/services/web-development/" element={<WebDevelopment />} />
        <Route path="/services/mobile-app-development/" element={<MobileAppDevelopment />} />
        <Route path="/services/software-consulting/" element={<SoftwareConsulting />} />
        <Route path="/services/third-party-integration/" element={<ThirdPartyIntegration />} />
        <Route path="/services/custom-development/" element={<CustomDevelopment />} />
        <Route path="/services/enterprise-application/" element={<EnterpriseApplication />} />
        <Route path="/services/digital-transformation" element={<DigitalTransformation />} />

        

        <Route path="/industries/logistics/" element={<Logistics />} />
        <Route path="/industries/healthcare/" element={<Healthcare />} />
        <Route path="/industries/financial-services/" element={<FinancialServices />} />
        <Route path="/industries/education/" element={<Education />} />
        <Route path="/industries/hospitality/" element={<Hospitality />} />
        <Route path="/industries/entertainment/" element={<Entertainment />} />
        <Route path="/industries/energy/" element={<Energy />} />
        <Route path="/industries/warehouse/" element={<Warehouse />} />
        <Route path="/industries/manufacture/" element={<Manufacture />} />
        <Route path="/industries/ecommerce/" element={<Ecommerce />} />
        <Route path="/industries/construction/" element={<Construction />} />
       
      
        <Route path="/company/our-advantages/" element={<OurAdvantages />} />
        <Route path="/company/our-story/" element={<OurStory />} />
        <Route path="/company/people-of-lentera/" element={<PeopleOfLentera />} />
        <Route path="/company/our-brand/" element={<OurBrand />} />
        <Route path="/company/careers/" element={<Careers />} />
        <Route path="/blogs" element={<BlogListing />} />
        <Route path="/blogs/category/:catSlug" element={<BlogListing />} />
        <Route path="/blog/:slug" element={<BlogDetail />} />

       
        <Route path="/contact/" element={<ContactUs />} />

        
        <Route path="/careers/sales-marketing/" element={<SalesandMarketing />} />
        <Route path="/careers/flutter-developer/" element={<Flutter />} />
        <Route path="/careers/angular-developer/" element={<Angular />} />
        <Route path="/careers/ui-ux-designer/" element={<Designer />} />
        <Route path="/careers/power-apps-developer/" element={<Power />} />
        <Route path="/careers/java-developer/" element={<JAVA />} />
        <Route path="/careers/react-developer/" element={<React />} />
        <Route path="/careers/python-developer/" element={<Python />} />
        <Route path="/careers/php-developer/" element={<PHP />} />

        {/* <Route path="/careers/hireus/" element={<Hireus />} /> */}
        {/* <Route path="/company/certifications/" element={<Certifications />} /> */}

       
        <Route path="/cookie-policy/" element={<Cookie />} />
        <Route path="/privacy-policy/" element={<Privacy />} />
        <Route path="/terms-condition/" element={<Terms />} />
        <Route path="/copyright-information/" element={<Copyrights />} />
        
      </Routes>
      <Footer/>
    </Router>
  );
}

export default App;
